import { styled } from '@ingrid/luterkort-react';
import { keyframes } from '@ingrid/luterkort-styles';

const animation = keyframes({
  '0%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(.6)' },
  '100%': { transform: 'scale(1)' },
});

const Dot = styled('div', {
  animation: `${animation} 1s infinite`,
  backgroundColor: 'black',
  borderRadius: '50%',
  height: '8px',
  width: '8px',

  variants: {
    mode: {
      dark: {
        backgroundColor: 'white',
      },
    },
  },
});

export function LoadingDot() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <Dot style={{ animationDelay: '0ms' }} />
      <Dot style={{ animationDelay: '100ms' }} />
      <Dot style={{ animationDelay: '200ms' }} />
    </div>
  );
}
